import React, { Fragment } from "react";
import MetaTagComponent from "../../../common/Meta/MetaTagComponent";
import { metaHireDedicated } from "../../../../Utilites";
import ServiceDetailSection from "../../../services/ServiceDetailSection";
import { Briefcase, ClipboardList, Clock, Cloud, Code, Code2, Database, DollarSign, Globe, MessageCircle, Repeat, Rocket, Server, Settings, Smartphone, Users } from "lucide-react";

const HireDedicated = () => {
  const service = {
    slug: "hire-dedicated",
    title: "Hire Dedicated Teams",
    description:
      "Skilled dedicated development teams that integrate seamlessly with your organization.",
    shortDescription: "Skilled dedicated development teams for your projects.",
    icon: Users,
    gradient: "from-cyan-500 to-blue-500",
    features: [
      "Dedicated Developers",
      "Project Managers",
      "Quality Assurance",
      "DevOps Engineers",
      "UI/UX Designers",
      "Business Analysts",
    ],
    benefits: [
      "Cost-Effective Solutions",
      "Scalable Teams",
      "Direct Communication",
      "Full Control Over Projects",
    ],
    process: [
      "Requirements Analysis",
      "Team Selection",
      "Onboarding Process",
      "Project Kickoff",
      "Ongoing Management",
    ],
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop",
  };

  const extension = {
  keyFeatures: [
    {
      name: "Dedicated Development Teams",
      description: "Get a full-time remote team fully aligned with your project goals and workflows",
      icon: Users,
    },
    {
      name: "Flexible Hiring Models",
      description: "Scale up or down easily with hourly, part-time, or full-time contracts",
      icon: Repeat,
    },
    {
      name: "Client-Centric Communication",
      description: "Daily stand-ups, weekly reports, and seamless collaboration tools",
      icon: MessageCircle,
    },
    {
      name: "Domain-Specific Expertise",
      description: "Access pre-vetted developers with experience in your industry",
      icon: Briefcase,
    },
    {
      name: "Project Management Support",
      description: "Optional PM and QA resources to enhance team productivity",
      icon: ClipboardList,
    },
    {
      name: "Timezone & Language Alignment",
      description: "Teams that work in your preferred time zone with fluent communication",
      icon: Clock,
    },
  ],

  benefits: [
    {
      title: "Faster Time to Market",
      description: "Accelerate delivery with a team that's ready to contribute from day one",
      icon: Rocket,
    },
    {
      title: "Cost-Effective Scaling",
      description: "Hire top talent without the overhead of in-house employment",
      icon: DollarSign,
    },
    {
      title: "Complete Team Control",
      description: "You manage the developers directly with full transparency and ownership",
      icon: Settings,
    },
    {
      title: "Access to Global Talent",
      description: "Tap into a global pool of specialized developers and tech experts",
      icon: Globe,
    },
  ],

  process: [
    {
      step: "Requirement Gathering",
      description: "Understand your project goals, team structure, and skill requirements",
      duration: "2–3 Days",
    },
    {
      step: "Talent Sourcing & Shortlisting",
      description: "Curate and present the best-matched candidates for your needs",
      duration: "3–5 Days",
    },
    {
      step: "Interview & Selection",
      description: "You interview and choose developers that fit your vision and culture",
      duration: "1 Week",
    },
    {
      step: "Onboarding & Kickoff",
      description: "Setup tools, workflows, and introduce team members to your environment",
      duration: "2–3 Days",
    },
    {
      step: "Ongoing Management & Support",
      description: "We provide administrative support while you focus on delivery",
      duration: "Ongoing",
    },
  ],

  techStack: [
    { name: "React / Next.js", icon: Code, category: "Frontend" },
    { name: "Node.js / Express", icon: Server, category: "Backend" },
    { name: "Python / Django", icon: Code2, category: "Backend" },
    { name: "Flutter / React Native", icon: Smartphone, category: "Mobile Development" },
    { name: "MongoDB / PostgreSQL", icon: Database, category: "Database" },
    { name: "AWS / Azure", icon: Cloud, category: "Cloud & DevOps" },
    { name: "Jira / Slack / Zoom", icon: MessageCircle, category: "Communication & Project Tools" },
  ],
};

  return (
    <Fragment>
      <MetaTagComponent metaDetails={metaHireDedicated} />
      <ServiceDetailSection service={service} extension={extension} />
    </Fragment>
  );
};

export default HireDedicated;
